
import React, { Component, useState } from 'react';
import { Button, Row, Col, Pagination } from 'react-bootstrap'
import ReportCard from '../components/ReportCard'
import PersonList from './PersonList'
import Story from './Story'
import SumStory from './SumStory'
import SumStoryPerson from './SumStoryPerson'
import HeaderText from './HeaderText'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import OverviewFilter from '../components/OverviewFilter'
import $ from 'jquery'
import DateSelect from './DateSelect'
import AuthService from "../controllers/AuthService";
import UserService from "../controllers/UserService";
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons';

class ReportButton extends Component {

    constructor(props) {
        super(props);
        this.callbackFromB = this.callbackFromB.bind(this);
        this.callPersonDetail = this.callPersonDetail.bind(this);
        this.callbackSelectDate = this.callbackSelectDate.bind(this);
        const search = window.location.search;
        const params = new URLSearchParams(search);
        this.state = {
            message: [],
            report1: btnReport1('overview'),
            report2: btnReport2('overview'),
            filter: [],
            count: '50',
            data: null,
            story1: btnStory1('sumstory'),
            story2: btnStory2('sumstory'),
            pagination: [],
            user: AuthService.getCurrentUser(),
            role: AuthService.getUserRole(),
            roomId: this.props.match.params.roomId,
            studentId: params.get('studentId'),
            filterStringQ: null,
            tabKey: 'overview',
            activityId: '',
            topicId: '',
            activityDate: '',
            dataMode: 'overview',
            currentStudentId: AuthService.getUserRole() === 'student' ? AuthService.getCurrentUser().id : '',
            currentStudentName: '',
            currentPage: 1,
            currentAllStudent: null,
            totalActivity: null,
            roomName: 'รายงาน Homeroom',
            textBtn: AuthService.getUserRole() === 'student' ? 'คำตอบของเรา' : 'คำตอบจากนักเรียน',
            classFillter: 'bg-white',
            classMainBg: 'bg-white',
            classShadow: '',
        };
    }


    componentDidMount() {
        UserService.getStudentInRoom(this.state.roomId).then(
            (res) => {
                let TempString = <div dangerouslySetInnerHTML={{ __html: 'รายงาน Homeroom <span class="doNotWrap"> ห้อง ' + res.data.data.displayName + '</span>' }} />;
                this.setState({ roomName: TempString });
            });

        if (this.state.role === 'student') {
            $('.btn-story-group').hide();
            this.setState({ currentStudentId: this.state.user.id });
            this.setState({ currentStudentName: this.state.user.fullName });
            this.setState({ dataMode: 'person' });
            this.personDetail();
        } else {
            if(this.state.studentId){
                UserService.getUserById(this.state.studentId).then(
                    (res) => {
                        $('.btn-story-group').hide();
                        this.setState({ currentStudentId: this.state.studentId });
                        this.setState({ currentStudentName: res.data.data.fullName });
                         var inputFilter = {
                            'studentId': this.state.user.id,
                            'status': 'FINISHED'
                        }
                        this.setState({ dataMode: 'person' });
                        this.personDetail(inputFilter);

                       
                    });
              
            } else {
                $('#date').hide();
                $('.btn-story-group').hide();
                this.overview()
                this.setState({ filter: this.getFilter('overview') });
            }
           
        }
       
    }


    callbackFromB(data) {

        this.setState({
            activityId: data.activityId,
            topicId: data.topicId,
            activityDate: data.date,
        }, () => {
            // this.renderSumStory(data);
            // this.getFilter('sumstory');
            this.updateContent('sumstory', data);
        });
        $('.btn-story-group').show();
        $('.btn-main-group').hide();
    }

    callPersonDetail(data, fullName) {
        this.setState({
            currentStudentId: data,
            currentStudentName: fullName,
        }, () => {
            this.randerPersonDetail({ 'studentId': data, 'fullName': fullName });

        });


    }

    callbackSelectDate(data) {
        this.setState({ currentPage: 1 });
        if ((data.to != undefined) && (data.from != undefined)) {
            $('#date').hide()
            var dateTempFrom = convertDate(new Date(data.from), 'iso');
            var dateTempTo = convertDate(new Date(data.to), 'iso', 1);

            var inputFilter;
            var temp;
            if (this.state.tabKey === 'overview') {
                inputFilter = {
                    'roomId': this.state.roomId,
                    'status': 'FINISHED',
                    'startDate': dateTempFrom,
                    'endDate': dateTempTo
                };
                temp = this.overview(inputFilter);
                this.setState({ message: temp });

            } else if (this.state.tabKey === 'personDetail') {
                inputFilter = {
                    'studentId': this.state.currentStudentId,
                    'status': 'FINISHED',
                    'startDate': dateTempFrom,
                    'endDate': dateTempTo
                }
                this.setState({ dataMode: 'person' });
                this.personDetail(inputFilter);
                // this.setState({ message: temp });
            }
        }
        // else {
        //     alert('กรุณาเลือกวัน');
        // }
    }

    updateContent = (menu, inputs = []) => {
        $('.personDetail-filter').show();
        console.log(menu);
        $('#date').hide()
        var data = '';
        var filter = '';
        if (menu === 'overview') {
            this.setState({
                currentStudentId: null,
                currentStudentName: null,
            })
            this.setState({ classFillter: "bg-white" });
            this.setState({ classMainBg: "bg-white" });
            data = this.overview()
            // filter = this.getFilter('overview') => move to over function
            this.setState({ message: data });
            var r1 = btnReport1(menu);
            var r2 = btnReport2(menu);
            this.setState({ report1: r1 });
            this.setState({ report2: r2 });
            $('.btn-story-group').hide();
            $('.btn-main-group').show();
            this.setState({ dataMode: menu });
        } else if (menu === 'person') {
            data = this.person()
            this.setState({ message: data });
            var r1 = btnReport1(menu);
            var r2 = btnReport2(menu);
            this.setState({ report1: r1 });
            this.setState({ report2: r2 });
            $('.btn-story-group').hide();
            $('.btn-main-group').show();
            this.setState({ dataMode: menu });
            filter = this.getFilter('person')
        }
        else if (menu === 'story') {
            this.renderStory(this.state.topicId, this.state.activityId, this.state.currentStudentId);
            filter = this.getFilter('story');
            var r1 = btnStory1(menu);
            var r2 = btnStory2(menu);
            this.setState({ story1: r1 });
            this.setState({ story2: r2 });
            $('.btn-story-group').show();
            $('.btn-main-group').hide();
        }
        else if (menu === 'sumstory') {
            this.renderSumStory(inputs);
            filter = this.getFilter('sumstory');
            var r1 = btnStory1(menu);
            var r2 = btnStory2(menu);
            this.setState({ story1: r1 });
            this.setState({ story2: r2 });
            $('.btn-story-group').show();
            $('.btn-main-group').hide();
        }
        else {

        }


    }


    renderStory = (data, activityId, studentId = null) => {
        this.setState({ classShadow: 'box-shadow-top' });
        this.setState({ classFillter: "bg-white" });
        this.setState({ classMainBg: "bg-white" });
        var story = <Story showExport="1" topicId={data} showQuestion="0" hideStart="1" activityId={activityId} studentId={studentId}/>
        this.setState({ message: story });
        $('.pageinage').hide();
    }

    renderSumStory = (inputs) => {
        this.setState({ classShadow: 'box-shadow-top' });
        this.setState({ classFillter: "bg-light-blue" });
        this.setState({ classMainBg: "bg-light-blue" });
        if (AuthService.getUserRole() === 'student' || this.state.dataMode === 'person') {
            var sumStory = <SumStoryPerson date={this.state.activityDate} activityId={this.state.activityId} studentId={this.state.currentStudentId} />
        } else {
            this.setState({ classFillter: "bg-light-blue" });
            this.setState({ classMainBg: "bg-light-blue" });
            var sumStory = <SumStory date={this.state.activityDate} activityId={this.state.activityId} />
        }
        this.setState({ message: sumStory });
        $('.pageinage').hide();
    }

    randerPersonDetail = (inputs = []) => {
        this.personDetail(inputs);

    }

    searchMaps() {
        // var data = this.person();
        var temp = $('#search').val();
        
        var currentStudent = this.state.currentAllStudent;
        // console.log(currentStudent);

        let a = currentStudent;
        var term = temp.replace(" ", ""); // search term (regex pattern)

    
        var search = new RegExp(term, 'i'); // prepare a regex object          
        let b = a.filter(item => search.test(item['student'].fullName + item['student'].no));
    
        this.setState({ classFillter: "bg-white" });
        this.setState({ classMainBg: "bg-white" });
        this.setState({ message: <PersonList dataDetail={b} ref={ref => (this.child = ref)} referenceCallback={this.callPersonDetail.bind(this)} /> });
    }


    getFilter(dataKey, inputs = null, count = 0) {

        if (dataKey != this.state.tabKey) {
            this.setState({ filterStringQ: {} });
            this.setState({ currentPage: 1 });

        }

        console.log('filterStringQ');
        console.log(this.state.filterStringQ);
        if (dataKey === 'overview') {
            this.setState({ tabKey: dataKey });
            $('.pageinage').show();
            return this.OverviewFilter(this.state.totalActivity, this.genDatePicker())
        } else if (dataKey === 'person') {
            // console.log('person');
            let DateSelection = this.OverviewFilter(this.state.totalActivity);
            $('.pageinage').hide();
            this.setState({
                filter:
                    <Row >
                        <Col xs={12} className="pb-4 pb-md-5 px-3 px-md-0 w-100">
                            <Col className="w-100 px-0" id="search-div">
                                <FontAwesomeIcon icon={faSearch} className="gray-text3 icon-search"></FontAwesomeIcon>
                                <input className="form-control form-control-sm w-100 border-radius-5 search" type="text" id="search" placeholder="ค้นหา ..." onInput={() => this.searchMaps()} />
                            </Col>
                        </Col>
                        <Col>
                            {DateSelection}
                        </Col>
                    </Row>
            });
        } else if ((dataKey === 'story' || dataKey === 'sumstory')) {
            $('.pageinage').hide();

            // console.log('setStory dataKey');
            if (this.state.dataMode != 'person') {
                this.setState({
                    filter:
                        <Row >
                            <Col style={{ "fontSize": '14px' }} className="text-left">
                                <span onClick={() => this.updateContent('overview')} style={{ "color": '#B6C2D5' }} className="click-pointer font-sarabun"> ภาพรวม &#62;</span> <span style={{ "color": '#848DA3' }} className="font-sarabun-bold">สรุปกิจกรรมวันที่ {this.state.activityDate}</span>
                            </Col>
                        </Row>
                });
            }
            else {

                if (this.state.role === 'student') {
                    this.setState({
                        filter:
                            <Row>
                                <Col xs={12} style={{ "fontSize": '14px' }} className="text-left pb-2">
                                    <span onClick={() => this.callPersonDetail(this.state.currentStudentId, this.state.currentStudentName)} style={{ "color": '#B6C2D5' }} className="click-pointer font-sarabun">{this.state.currentStudentName} &#62;</span> <span style={{ "color": '#848DA3' }} className="font-sarabun-bold">สรุปกิจกรรมวันที่ {this.state.activityDate}</span>
                                </Col>
                            </Row>
                    });
                } else {
                    this.setState({
                        filter:
                            <Row>
                                <Col xs={12} style={{ "fontSize": '14px' }} className="text-left pb-2">
                                    <span onClick={() => this.updateContent('person')} style={{ "color": '#B6C2D5' }} className="click-pointer font-sarabun"> รายบุคคล &#62;</span> <span onClick={() => this.callPersonDetail(this.state.currentStudentId, this.state.currentStudentName)} style={{ "color": '#B6C2D5' }} className="click-pointer font-sarabun">{this.state.currentStudentName} &#62;</span> <span style={{ "color": '#848DA3' }} className="font-sarabun-bold">สรุปกิจกรรมประจำวันที่ {this.state.activityDate}</span>
                                </Col>
                            </Row>
                    });
                }

            }

        } else if (dataKey === 'personDetail') {
            $('.pageinage').show();
            let DateSelection = this.OverviewFilter(count, this.genDatePicker());

            if (this.state.role != 'student') {
                this.setState({
                    filter:
                        <Row>
                            <Col xs={12} style={{ "fontSize": '14px' }} className="text-left pb-2">
                                <span onClick={() => this.updateContent('person')} style={{ "color": '#B6C2D5' }} className="click-pointer"> รายบุคคล &#62;</span><span style={{ "color": '#848DA3' }}> {inputs.fullName}</span>
                            </Col>
                            <Col xs={12}>
                                {DateSelection}
                            </Col>
                        </Row>
                });
            } else {
                this.setState({
                    filter:
                        <Row>
                            <Col xs={12} style={{ "fontSize": '14px' }} className="text-left pb-2">
                                {/* <span onClick={() => this.updateContent('person')}> รายบุคคล </span>  &#62; {inputs.fullName} */}
                            </Col>
                            <Col xs={12}>
                                {DateSelection}
                            </Col>
                        </Row>
                });
            }
        } else {
            return dataKey;
        }

        this.setState({ tabKey: dataKey });
    }

    personDetail(inputFilter = null) {
        var filterTemp = {};
        console.log('personDetail');
        console.log(this.state.role);
        if (this.state.role === 'student') {
            $('.btn-story-group').hide();
        }
        if (inputFilter) {
            filterTemp = inputFilter;
        }
        filterTemp.studentId = this.state.currentStudentId;
        filterTemp.status = 'FINISHED';
        filterTemp.domain = AuthService.getCurrentUser().domain.name 
        const items = []

        var user = AuthService.getCurrentUser();
        //todo ปีการศึกษา        
        var filter;        

        UserService.getRoomDetail(this.state.roomId).then((response) => {              
          
                filterTemp.roomId = this.state.roomId;
                filterTemp.year = response.data.data.year;
                filterTemp.term = response.data.data.term;              
         
        }).then(() => {

            UserService.getActivities(filterTemp).then(
                (res) => {
                    // console.log('getActivitiesByStudentId')
                    console.log(res)
                    const items = []

                    for (const [index, value] of res.data.data.entries()) {                    
                        console.log(value.createdAt);
                        const dateTemp = new Date(value.createdAt[0], value.createdAt[1] - 1, value.createdAt[2]);
                        var dateTemp1 = convertDate(dateTemp, 'desktop');
                        // var dateTemp2 = convertDate(dateTemp, 'mobile');
                        // var date = `<div><span class="d-none d-md-block">${dateTemp1}</span><span class="d-block d-md-none ">${dateTemp2}</span></div>`;
                        var date = `<div>${dateTemp1}</div>`;
                        var dateString = convertDate(dateTemp, 'datestring');

                        var shortTilte = value.topic.title;

                        if (value.topic.title.length > 60) {
                            shortTilte = shortTilte.substring(0, 57) + " ...";
                        }

                        var temp = {
                            date: date,
                            topic: shortTilte,
                            attenders: value.total,
                            export: 'export1',
                            activityId: value.id,
                            topicId: value.topic.id,
                            dateString: dateString,
                        };
                        items.push(temp);
                    }
                    this.setState({ filterStringQ: filterTemp });
                    this.getFilter('personDetail', { 'fullName': this.state.currentStudentName }, res.data.total);
                    this.setState({ classFillter: "bg-white" });
                    this.setState({ classMainBg: "bg-white" });
                    this.setState({ message: <ReportCard dataDetail={items} showDetail={"student"} studentId={this.state.currentStudentId} role={this.state.role} ref={ref => (this.child = ref)} referenceCallback={this.callbackFromB.bind(this)} /> });

                    //get getPagination

                    var mod = res.data.total % 50;
                    var totalPage = (res.data.total / 50)
                    if (mod > 0) {
                        totalPage = totalPage + 1;
                    }
                    this.getPagination(parseInt(totalPage), this.state.currentPage)
                    // this.getPagination(10, this.state.currentPage);
                },
                (error) => {
                    //   console.log(resMessage);
                }
            );
        
        });
     
    }

    overview(inputFilter = null) {

        this.setState({ classFillter: "bg-white" });
        this.setState({ classMainBg: "bg-white" });
        this.setState({ classShadow: '' });
        var filterTemp = {
            roomId: '',
            status: '',
        };
        if (inputFilter) {
            filterTemp = inputFilter;
        }

        filterTemp.roomId = this.state.roomId;
        filterTemp.status = 'FINISHED';
        filterTemp.domain = AuthService.getCurrentUser().domain.name 

        UserService.getActivities(filterTemp).then(
            (res) => {
                // console.log('get activities result')
                // console.log(res)
                const items = []

                for (const [index, value] of res.data.data.entries()) {
                    const dateTemp = new Date(value.createdAt[0], value.createdAt[1] - 1, value.createdAt[2]);
                    var dateTemp1 = convertDate(dateTemp, 'desktop');
                    // var dateTemp2 = convertDate(dateTemp, 'mobile');
                    // var date = `<div><span class="d-none d-md-block">${dateTemp1}</span><span class="d-block d-md-none ">${dateTemp2}</span></div>`;
                    var date = `<div>${dateTemp1}</div>`;
                    var dateString = convertDate(dateTemp, 'datestring');
                    var shortTilte = value.topic.title;

                    if (value.topic.title.length > 60) {
                        shortTilte = shortTilte.substring(0, 57) + " ...";
                    }
                    var temp = {
                        date: date,
                        topic: shortTilte,
                        attenders: (value.attenders) ? value.attenders.length : 0,
                        export: 'export1',
                        activityId: value.id,
                        topicId: value.topic.id,
                        dateString: dateString,
                    };
                    items.push(temp);
                }
                this.setState({ filterStringQ: filterTemp });
                this.setState({ totalActivity: res.data.total });
                this.setState({ filter: this.getFilter('overview') });
                this.setState({ message: <ReportCard dataDetail={items} role={this.state.role} ref={ref => (this.child = ref)} referenceCallback={this.callbackFromB.bind(this)} /> });

                var mod = res.data.total % 50;
                var totalPage = (res.data.total / 50)
                if (mod > 0) {
                    totalPage = totalPage + 1;
                }
                //get getPagination
                this.getPagination(parseInt(totalPage), this.state.currentPage);
                //this.getPagination(10, this.state.currentPage);

            },
            (error) => {
                //   console.log(resMessage);
            }
        );
    }

    person(inputFilter = null) {
        this.setState({ classShadow: '' });
        var filterTemp = null;
        if (inputFilter) {
            filterTemp = inputFilter;
        }
        UserService.getStudentsAndActivitiesCountByRoomId(this.state.roomId).then((res) => {
            if (res && res.data && res.data.data) {
                this.setState({ currentAllStudent: res.data.data });
                return res.data.data
            }
            return []
        },
            (error) => {
                //   console.log(resMessage);

            }).then((res) => {
                // console.log('getStudentsAndActivitiesCountByRoomId');
                // console.log(res);
                this.setState({ classFillter: "bg-white" });
                this.setState({ classMainBg: "bg-white" });
                this.setState({ message: <PersonList dataDetail={res} ref={ref => (this.child = ref)} referenceCallback={this.callPersonDetail.bind(this)} /> });

            },
                (error) => {
                    //   console.log(resMessage);
                });

    }

    genDatePicker() {
        var divDateA = <div id="date"><DateSelect ref={ref => (this.child = ref)} referenceCallback={this.callbackSelectDate.bind(this)} /></div>
        return divDateA;
    }

    getPagination(totalPage = 3, currentPage = 1) {

        var range = 3;

        if (totalPage < range) {
            range = totalPage;
        }

        const paging = { range: range, pages: totalPage };
        var pageArray = doPaging(currentPage, paging);
        // console.log(totalPage, currentPage, pageArray);
        var classP = '';
        var classN = '';
        if (pageArray.length === 0) {
            return '';
        }
        if (currentPage === 1) {
            classP = "disabled"
        }

        if (currentPage === totalPage) {
            classN = "disabled"
        }

        if (totalPage === 1) {

            var html = '';
        } else if (totalPage === 2) {

            var html = <Pagination>
                <Pagination.First className='disabled' />
                <Pagination.Item className={pageArray[0]['status']} onClick={() => this.handlePaginationClick(pageArray[0]['id'])} >{pageArray[0]['id']}</Pagination.Item>
                <Pagination.Item className={pageArray[1]['status']} onClick={() => this.handlePaginationClick(pageArray[1]['id'])} >{pageArray[1]['id']}</Pagination.Item>
                <Pagination.Last className='disabled' />
            </Pagination>
        } else if (totalPage === 3) {
            var html = <Pagination>
                <Pagination.First className='disabled' />
                <Pagination.Item className={pageArray[0]['status']} onClick={() => this.handlePaginationClick(pageArray[0]['id'])} >{pageArray[0]['id']}</Pagination.Item>
                <Pagination.Item className={pageArray[1]['status']} onClick={() => this.handlePaginationClick(pageArray[1]['id'])} >{pageArray[1]['id']}</Pagination.Item>
                <Pagination.Item className={pageArray[2]['status']} onClick={() => this.handlePaginationClick(pageArray[2]['id'])} >{pageArray[2]['id']}</Pagination.Item>
                <Pagination.Last className='disabled' />
            </Pagination>
        } else {
            var html = <Pagination>
                <Pagination.First className={classP} onClick={() => this.handlePaginationClick(1)} />
                <Pagination.Item className={pageArray[0]['status']} onClick={() => this.handlePaginationClick(pageArray[0]['id'])} >{pageArray[0]['id']}</Pagination.Item>
                <Pagination.Item className={pageArray[1]['status']} onClick={() => this.handlePaginationClick(pageArray[1]['id'])} >{pageArray[1]['id']}</Pagination.Item>
                <Pagination.Item className={pageArray[2]['status']} onClick={() => this.handlePaginationClick(pageArray[2]['id'])} >{pageArray[2]['id']}</Pagination.Item>
                <Pagination.Last className={classN} onClick={() => this.handlePaginationClick(totalPage)} />
            </Pagination>
        }


        this.setState({
            pagination: html
        });
    }

    handlePaginationClick(page) {        // filterStringQ: null,

        this.setState({
            currentPage: page
        });
        var inputFilter = this.state.filterStringQ;
        var tabKey = this.state.tabKey;
        // console.log('handlePaginationClick');

        inputFilter.page = page - 1;
        if (tabKey === 'overview') {
            // console.log(inputFilter, page);
            this.overview(inputFilter);
        } else if (tabKey === 'personDetail') {
            this.personDetail(inputFilter);
        }
    }

    OverviewFilter(key, selectDate = null) {
        // const [startDate, setStartDate] = '';
        // const [endDate, setEndDate] = '';
        const clickData = () => {
            if ($('#date').css('display') === 'none') {
                $('#date').show();
            } else {
                $('#date').hide();
            }
        }

        if (selectDate != null) {
            return (
                <Row className="select-date">
                    <Col xs={5} className="position-relative t-b-14">
                        <div className="text-left click-pointer" onClick={() => { clickData(); }}><img src='/images/icons/calendar_blue.png' className="mb-1 d-inline pr-2" /><h5 className="primary-text d-inline mb-0 click-pointer font-sarabun-bold">เลือกวันที่</h5></div>
                        {selectDate}
                    </Col>
                    <Col xs={7} className="text-right t-b-14 pl-0">
                        {/* <img src='/images/icons/Group 155.png' className="d-inline" />  */}
                        <h5 className="primary-text d-inline mb-0 font-sarabun-bold">จำนวนเรื่องราว {key} เรื่อง</h5>
                    </Col>
                </Row>

            );
        } else {
            return (
                <Row className="select-date">
                    <Col xs={5} className="position-relative">
                    </Col>
                    <Col xs={7} className="text-right">
                        <h5 className="primary-text d-inline mb-0 font-sarabun-bold">จำนวนเรื่องราว {key} เรื่อง</h5>
                    </Col>
                </Row>

            );
        }
    };

    render() {
        return (
            <div className="report-overview">

                <Col className="header-text">
                    <HeaderText text1={this.state.roomName} cardTitle="" text2="" />
                </Col>

                { (this.state.role !== "student") && (
                    <div className="py-3 btn-main-group bg-light-blue">
                        <Button variant="report-menu m-2 py-md-1 btn-repot font-sarabun" className={this.state.report1} onClick={() => this.updateContent('overview')}>ภาพรวม</Button>
                        <Button variant="report-menu m-2 py-md-1 btn-repot font-sarabun" className={this.state.report2} onClick={() => this.updateContent('person')}>รายบุคคล</Button>
                    </div>
                )}

                { (this.state.role === "student") && (
                    <div className="">
                    </div>

                )}

                <div className="py-0 py-3 btn-story-group bg-white">
                    <Button variant="report-menu m-2 py-md-1 btn-repot font-sarabun" className={this.state.story1} onClick={() => this.updateContent('story')}>เรื่องราว</Button>
                    <Button variant="report-menu m-2 py-md-1 btn-repot font-sarabun" className={this.state.story2} onClick={() => this.updateContent('sumstory')}>{this.state.textBtn}</Button>
                </div>
                <div className={`py-0 px-0 ${this.state.classMainBg} `}>
                    {/* py-3 px-3  */}
                    <div className={`mb-3 px-0 pt-4 pt-md-5 ${this.state.classFillter} ${this.state.classShadow}`} >
                        <div className="main-detail px-4">
                            {this.state.filter}
                        </div>
                    </div>
                    <div className="text-center data-div px-3 font-sarabun">
                        {this.state.message}
                    </div>
                </div>
                <div className="m-5 pageinage">
                    <div className="d-flex justify-content-center w-100">
                        {this.state.pagination}
                    </div>

                </div>

            </div>
        );
    }
}

function btnReport1(selectMenu) {
    if (selectMenu === 'overview') {
        //return "btn-mm-danger font-weight-600";
        return "btn-mm-danger";
    } else {
        return "btn-mm-outline-danger";
    }
}

function btnReport2(selectMenu) {
    if (selectMenu === 'person') {
        // return "btn-mm-danger font-weight-600";
        return "btn-mm-danger";
    } else {
        return "btn-mm-outline-danger";
    }
}

function btnStory1(selectMenu) {
    if (selectMenu === 'story') {
        // return "btn-mm-danger font-weight-600";
        return "btn-mm-danger";
    } else {
        return "btn-mm-outline-danger";
    }
}

function btnStory2(selectMenu) {
    if (selectMenu === 'sumstory') {
        // return "btn-mm-danger font-weight-600";
        return "btn-mm-danger";
    } else {
        return "btn-mm-outline-danger";
    }
}

function convertDate(dateTime, formatDate = 'mobile', adjustDate = 0) {
    console.log(dateTime);
    if (adjustDate !== 0) {
        // dateTime = new Date(dateTime);
        // dateTime = dateTime.setDate(dateTime.getDate() + adjustDate);
        // console.log('dateTime');
        // console.log(dateTime);

        var day = new Date(dateTime);
        var tempDay = new Date(day);
        tempDay.setDate(day.getDate() + adjustDate);
        dateTime = tempDay;
    }

    var formattedDate = ('0' + dateTime.getDate()).slice(-2);
    var formattedMonth = ('0' + (dateTime.getMonth() + 1)).slice(-2);
    // Combine and format date string
    if (formatDate === 'mobile') {
        var formattedYear = dateTime.getFullYear().toString().substr(2, 2);
        return formattedMonth + '/' + formattedDate + '/' + formattedYear;
    } else if (formatDate === 'desktop') {
        return formattedDate + '/' + formattedMonth + '/' + dateTime.getFullYear().toString();
    } else if (formatDate === 'iso') {
        return dateTime.toISOString();
    } else if (formatDate === 'datestring') {
        var months_th = ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม",];
        var temp = dateTime.getFullYear() + 543;
        return dateTime.getDate() + ' ' + months_th[dateTime.getMonth()] + ' ' + temp;
    }

    return '';
}



function doPaging(current, { range, pages, start = 1 }) {


    const paging = [];
    var i = Math.min(pages + start - range, Math.max(start, current - (range / 2 | 0)));
    const end = i + range;
    // while (i < end) { paging.push(i === current ? `[${i++}]` : `${i++}`) }
    while (i < end) {
        paging.push({ "status": i === current ? `active` : ``, "id": `${i++}` })
    }
    return paging;
}
export default withRouter(ReportButton);